import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useProductDispatch, useProductStore } from '../ProductProvider';
import NavProduct from '../tabs/NavProduct';
import TabBundles from '../tabs/TabBundles';
import TabMedia from '../tabs/TabMedia';
import TabSpecs from '../tabs/TabSpecs';
import TabSupport from '../tabs/TabSupport';
import styles from './index.module.scss';
import ProductContent from './ProductContent';

const theme = 'white';
const tabList = ['Product', 'Support', 'Specs', 'Media'];
export default function Detail() {
    const { productTabActive } = useProductStore();
    const dispatch = useProductDispatch();
    const router = useRouter();
    const { locale, query } = router;
    const tabName: string = (query.tab as string) || '';
    useEffect(() => {
        if (tabName && tabList.includes(tabName)) {
            dispatch({
                type: 'changeProductTabActive',
                payload: tabName,
            });
        }
    }, [tabName]);

    return (
        <div className={styles.detail}>
            <NavProduct />
            <div className={`product-item-tab${productTabActive === 'Product' ? ' product-item-tab-active' : ''}`}>
                <ProductContent />
            </div>
            {productTabActive === 'Bundles' && (
                <div className={`product-item-tab product-item-tab-active`}>
                    <TabBundles />
                </div>
            )}
            {productTabActive === 'Support' && (
                <div className={`product-item-tab product-item-tab-active`}>
                    <TabSupport theme={theme} />
                </div>
            )}
            {productTabActive === 'Specs' && (
                <div className={`product-item-tab product-item-tab-active`}>
                    <TabSpecs theme={theme} />
                </div>
            )}
            <div className={`product-item-tab${productTabActive === 'Media' ? ' product-item-tab-active' : ''}`}>
                <TabMedia />
            </div>
        </div>
    );
}
